import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';

import { Category } from 'ish-core/models/category/category.model';

/**
 * The Category Image Component renders an HTML tag img of an image of a Category.
 */

@Component({
  selector: 'custom-category-image',
  templateUrl: './custom-category-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class CustomCategoryImageComponent implements OnChanges {
  /**
   * The category for which the image should be displayed
   */
  readonly category = input<Category>(undefined);

  categoryImageUrl = '/assets/img/not-available.svg';

  ngOnChanges() {
    this.setCategoryImageUrl();
  }

  /**
   * Set the category image URL from the (non-)empty property effectiveUrl.
   * The URL to a non-empty effectiveUrl has a prefix URL of property icmBaseURL.
   */
  setCategoryImageUrl() {
    const category = this.category();
    if (category.images?.[0]?.effectiveUrl?.length > 0) {
      this.categoryImageUrl = `${category.images[0].effectiveUrl}`;
    }
  }
}
